// import IM from './im'
import cloneDeep from "lodash/cloneDeep"

export default {
  state: {
    singleList: [],
  },
  mutations: {
    SET_SINGLELIST(state, list) {
      state.singleList = list
    },
    DISMISSSINGLE(state, accId) {
      let arr = cloneDeep(state.singleList)
      let ind = arr.findIndex(i => i.accId === accId)
      if (ind !== -1) arr.splice(ind, 1)
      state.singleList = arr
    }
  },
  actions: {
    singleUpdate({ state, getters, commit, dispatch }, data) {
      const singleMap = {}
      let arr = cloneDeep(state.singleList)
      arr.forEach(i => {
        if (i.accId) singleMap[i.accId] = i
      })
      if (Array.isArray(data)) {
        data.forEach(i => {
          if (i.accId && singleMap[i.accId]) {
            let ind = arr.findIndex(item => item.accId === i.accId);
            if (ind === -1) {
              arr.push({ ...(singleMap[i.accId] || {}), ...i })
            } else {
              arr.splice(ind, 1, { ...(singleMap[i.accId] || {}), ...i })
            }
          } else if (i.accId && !singleMap[i.accId]) {
            arr.push({ ...(singleMap[i.accId] || {}), ...i })
          }
        })
      } else {
        let ind = arr.findIndex(i => i.accId === data.accId);
        if (ind === -1) {
          arr.push(data)
        } else {
          arr.splice(ind, 1, { ...arr[ind], ...data })
        }
      }
      if (state.currentSession) {
        if (!getters.teamsMap[state.currentSession] && !arr.find(i => i.accId === state.currentSession)) {
          dispatch('setCurrentSession')
        }
      }
      commit('SET_SINGLELIST', arr)
    }
  },
  getters: {
    singleMap(state) {
      const singleMap = {}
      state.singleList.forEach(i => {
        if (i.accId) singleMap[i.accId] = i
      })
      return singleMap
    },
  }
}
